/**
 * Returning to an AI connection request after sign-in. Only the consent page's own address is
 * remembered, so this can never become an open redirect.
 */
const KEY='vantage_return_path';
const ALLOWED=/^\/connect-ai\?request=[0-9a-f-]{36}$/;

export function rememberReturnPath(path:string){
  try{if(ALLOWED.test(path))sessionStorage.setItem(KEY,path);else sessionStorage.removeItem(KEY);}catch{/* storage unavailable */}
}
/** The remembered connection request (once), otherwise the fallback. */
export function afterSignIn(fallback:string){
  try{const path=sessionStorage.getItem(KEY);sessionStorage.removeItem(KEY);if(path&&ALLOWED.test(path))return path;}catch{/* storage unavailable */}
  return fallback;
}
